module.exports = __webpack_public_path__ + "static/media/Burger.2a210d44.png";